import assetPath from '/app/packages/master-directory/head/src/assets/og-xing-logo.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')